import React from 'react'

const LimitedViewText = ({ short }) => (
  <React.Fragment>
    <span aria-label="Purchase to discover!" className="tooltip-flirt" data-balloon-pos="up">
      <span className="blur">
        {short ? 'Lorem ipsum is placeholder' : 'Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups.'}
      </span>
    </span>
  </React.Fragment>
);

export default LimitedViewText
